module.exports = __webpack_public_path__ + "img/store-apple.07ebdec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/content/store-apple.png
// module id = 8PQR
// module chunks = 33